import React from 'react'
import Icon from '@roo/roo/Icon'
import { getLanguage, languageOptions } from '@/common/utils/i18n'
import styles from './index.module.less'
import EarthSvg from '../Icons/EarthSvg'
import { DropMenu } from '@roo/roo'

const LangeSelector = () => {
  const currentLang = getLanguage()
  const langLabel = languageOptions.find(item => item.value === currentLang)?.label || 'English'

  return (
    <div className={styles.container}>
      <DropMenu
        menu={languageOptions}
        popupClassName={styles.popup_content}
        onItemClick={item => {
          localStorage.setItem('i18nLocale', item.value)
          window.location.reload()
        }}
        style={{ width: '105px' }}
      >
        <div className={styles.content}>
          <EarthSvg size="14"/>
          <span>&nbsp;{langLabel}&nbsp;</span>
          <Icon name="chevron-down" size={16} />
        </div>
      </DropMenu>
    </div>
  )
}

export default LangeSelector